import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';
import { PedidoNaoLiberadoCardInfoModule } from '../card-info';

import { PedidoLiberarModalComponent } from './pedido-liberar-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        PedidoNaoLiberadoCardInfoModule
    ],
    declarations: [
        PedidoLiberarModalComponent
    ],
    exports: [
        PedidoLiberarModalComponent
    ]
})
export class PedidoLiberarModalModule { }
